import { PASSWORD } from "./action";

const initialState = {
  tokenSent: {},
  resetDone: {}
};

export default function resetPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case PASSWORD.tokenRequest.success:
    case PASSWORD.tokenRequest.error:
      return {
        ...state,
        tokenSent: action.data
      };
    case PASSWORD.resetRequest.success:
    case PASSWORD.resetRequest.error:
      return {
        ...state,
        resetDone: action.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/forgotPassword/reducer.js